<template>
    <div class="select-account">
        <div class="select-account__head">
            <h3>Выберите счет списания</h3>
            <button @click="$store.commit('changeSelectAccount', false)">
                <img src="@/assets/images/close-circle.svg" alt="">
            </button>
        </div>
        <div class="search-assets__inp">
            <button>
                <img src="@/assets/images/search-icon.svg" alt="">
            </button>
            <input type="text" placeholder="Поиск">
        </div>
        <ul class="select-account__list">
            <li v-for="i in 27" :key="i">
                <h4>USD</h4>
                <p>
                    21 860.02
                    <span>$</span>
                </p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "SelectAccount"
}
</script>

<style>

</style>